import { MDCSwitch } from '@material/switch'

export default {
  setup() {
    this.switch = new MDCSwitch(this.el)
  },
  destroy() {
    this.switch?.destroy()
    this.switch = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
